export enum SurfaceOperation {
	ADD = 'ADD',
	REMOVE = 'REMOVE',
	REPLACE = 'REPLACE',
}
